import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useSetAtom } from "jotai";

import { QUERY_KEYS } from "../constants";
import { handleForfeitTournamentEntry } from "../../api-clients/tournamentsClient";
import { showSuccessToast } from "../../utils/show-toast";
import { gameFlowStateAtomWithStorage } from "../../jotai/atoms/games";
import { GameFlowState } from "../../utils/constants";

function useForfeitTournamentEntryMutation(redirectUrl?: string) {
  const navigate = useNavigate();
  const setGameFlowState = useSetAtom(gameFlowStateAtomWithStorage);

  const mutation = useMutation({
    mutationKey: [QUERY_KEYS.TOURNAMENT.FORFEIT_ENTRY],
    mutationFn: (entryId: string) => handleForfeitTournamentEntry(entryId),
    onSuccess: () => {
      showSuccessToast("Game Entry forfeited successfully");
      if (!redirectUrl) return;
      setGameFlowState(GameFlowState.VIEWING_RESULTS_FOR_FAILED_GAME);
      navigate(redirectUrl);
    },
  });

  const forfeitEntry = (entryId: string) => {
    mutation.mutate(entryId);
  };

  return { mutation, forfeitEntry };
}

export default useForfeitTournamentEntryMutation;
